import { aboutInfo } from '@/mocks/about';

export default function BrandStory() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
              品牌故事
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              {aboutInfo.description}
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              {aboutInfo.mission}
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {aboutInfo.values.map((v) => (
                <div key={v.title} className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 shrink-0 mt-0.5">
                    <i className={`${v.icon} text-lg`}></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-800 mb-1">{v.title}</h4>
                    <p className="text-xs text-foreground-500 leading-relaxed">{v.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="order-1 lg:order-2">
            <div className="aspect-square w-full rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20Chinese%20artisan%20workshop%20with%20woodcarving%20tools%20and%20half-finished%20jade%20pieces%20on%20wooden%20table%2C%20warm%20natural%20light%20from%20window%2C%20traditional%20craftsmanship%20atmosphere%2C%20cream%20walls%2C%20artistic%20lifestyle%20scene&width=800&height=800&seq=brand-story-01&orientation=squarish"
                alt="掌中之物品牌故事"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}